<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(TWENTY_MINUTES)"
        translate>
        Remind me in 20 minutes
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(ONE_HOUR_IN_MINUTES)"
        translate>
        Remind me in 1 hour
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(THREE_HOURS_IN_MINUTES)"
        translate>
        Remind me in 3 hours
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(ONE_DAY_IN_MINUTES)"
        translate>
        Remind me in 1 day
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(TWO_DAYS_IN_MINUTES)"
        translate>
        Remind me in 2 days
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(SEVEN_DAYS_IN_MINUTES)"
        translate>
        Remind me in 7 days
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(FOURTEEN_DAYS_IN_MINUTES)"
        translate>
        Remind me in 14 days
    </button>
</li>
<li role="menuitem">
    <button
        [disabled]="isSaving"
        class="dropdown-item"
        type="button"
        (click)="remindClick.emit(THIRTY_DAYS_IN_MINUTES)"
        translate>
        Remind me in 30 days
    </button>
</li>
<li role="menuitem">
    <button [disabled]="isSaving" class="dropdown-item" type="button" (click)="pickDateAndTimeClick.emit()" translate>
        Pick date & time
    </button>
</li>

@if (hasReopenOption) {
    <li class="divider dropdown-divider"></li>
    <li role="menuitem" class="ps-3" (click)="$event.stopPropagation()">
        <label class="checkbox__label checkbox__label--size-small">
            Open after reminder ended
            <input
                type="checkbox"
                [disabled]="isSaving"
                [checked]="isReopen"
                (click)="isReopenClick.emit(!isReopen); $event.preventDefault()" />
            <span class="checkbox__checkmark"></span>
        </label>
    </li>
}

@if (isReminderAdded) {
    <li class="divider dropdown-divider"></li>
    <li role="menuitem">
        <button [disabled]="isSaving" class="dropdown-item" (click)="removeReminderClick.emit()" translate>
            Remove reminder
        </button>
    </li>
}
